// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-color-js": () => import("/opt/build/repo/src/pages/color.js" /* webpackChunkName: "component---src-pages-color-js" */),
  "component---src-pages-gradients-js": () => import("/opt/build/repo/src/pages/gradients.js" /* webpackChunkName: "component---src-pages-gradients-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-palettes-js": () => import("/opt/build/repo/src/pages/palettes.js" /* webpackChunkName: "component---src-pages-palettes-js" */)
}

